import React, { useState, useEffect } from 'react';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const PrivacyPolicy = () => {
  const navigate = useNavigate();
  const [language, setLanguage] = useState('es');

  useEffect(() => {
    const storedLang = localStorage.getItem('autogoLanguage') || 'es';
    setLanguage(storedLang);
  }, []);

  const content = {
    es: {
      backButton: 'Volver al inicio',
      title: 'Política de Privacidad',
      note: '',
    },
    en: {
      backButton: 'Back to home',
      title: 'Privacy Policy',
      note:
        'Note: This legal document is available in Spanish only, as it refers to Spanish and European legislation (GDPR, LOPD-GDD, LSSI-CE).',
    },
  };

  const t = content[language];

  return (
    <div className="min-h-screen bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <button
          type="button"
          onClick={() => navigate('/')}
          className="flex items-center gap-2 text-[#0A4F6E] hover:text-[#39FF77] mb-8 transition-colors"
        >
          <ArrowLeft className="w-5 h-5" />
          {t.backButton}
        </button>

        <h1 className="text-4xl font-bold text-[#0A4F6E] mb-8">{t.title}</h1>

        {language === 'en' && (
          <div className="bg-blue-50 border-l-4 border-blue-500 p-4 mb-8">
            <p className="text-sm text-blue-700">{t.note}</p>
          </div>
        )}

        <div className="prose prose-lg max-w-none">
          <h2 className="text-2xl font-bold text-[#0A4F6E] mt-8 mb-4">A RELATIVA A LA PROTECCIÓN DE DATOS</h2>
          <p className="mb-4">
            PYRAMID LOGISTICS SL, en adelante AUTOGO, será el responsable de los datos personales del usuario y garantizará la adopción de las medidas técnicas y organizativas de seguridad y confidencialidad necesarias para gestionar los datos del usuario con carácter personal en conformidad con lo que se establece en el Reglamento (UE) 2016/679 del Parlamento Europeo y del Consejo, de 27 de abril de 2016, relativo a la protección de las personas físicas en lo que respecta al tratamiento de datos personales y a la libre circulación de estos datos y por el que se deroga la Directiva 95/46/CE (Reglamento general de protección de datos, RGPD); la Ley Orgánica 3/2018, de 5 de diciembre, de Protección de Datos Personales y garantía de los derechos digitales (LOPD-GDD) y la Ley 34/2002, de 11 de julio, de Servicios de la Sociedad de la Información y de Comercio Electrónico (LSSI-CE).
          </p>

          <h2 className="text-2xl font-bold text-[#0A4F6E] mt-8 mb-4">2.- FIN DEL TRATAMIENTO DE DATOS PERSONALES</h2>
          <p className="mb-4">
            Los datos personales recabados mediante esta página web facilitados por el usuario serán añadidos y tratados en los ficheros de AUTOGO con el fin de impulsar los servicios de la plataforma, comunicarse con usted, tramitar las transacciones y mejorar la calidad, funcionamiento y navegación del Sitio Web. Mediante esta información personal, AUTOGO podrá gestionar las órdenes de los usuarios, y podrá ofrecerle una comunicación completa sobre los servicios de la plataforma, al poder enviarle ofertas e información comercial de la plataforma, newsletters.
          </p>
          <p className="mb-4">
            AUTOGO sólo recogerá datos del usuario que sean relevantes para llevar a cabo estos fines, y procurará que estos datos sean exactos, completos y actuales. AUTOGO se compromete a salvaguardar sus intereses mediante la protección de sus datos personales al adoptar las medidas de protección administrativas, técnicas y físicas necesarias para tal fin, siempre de acuerdo con la normativa vigente.
          </p>
          <p className="mb-4">
            Los datos personales que se recogerán serán: el nombre, los datos fiscales, la fecha de nacimiento, la dirección postal, el número de teléfono, el correo electrónico, la contraseña de la cuenta de usuario, los datos de la tarjeta bancaria para realizar las transacciones, el historial de órdenes, el historial de navegación, etc.
          </p>

          <h3 className="text-xl font-bold text-[#0A4F6E] mt-6 mb-3">2.1.- TERCERAS PARTES</h3>
          <p className="mb-4">
            AUTOGO se asegurará de que los datos proporcionados por el usuario no se tergiversen, dañen o que terceras partes no autorizadas tengan acceso a ellos. En concreto, AUTOGO transmitirá estos datos personales a contratistas y subcontratistas que trabajan bajo sus órdenes y que intervienen y contribuyen en la gestión de éstas y para las cuales es necesario el acceso a estos datos personales, que los proporciona cuando crea y usa su cuenta.
          </p>

          <h2 className="text-2xl font-bold text-[#0A4F6E] mt-8 mb-4">3.- FUNDAMENTO LEGAL DEL TRATAMIENTO DE DATOS</h2>
          <p className="mb-4">
            AUTOGO solo tendrá un fundamento jurídico para el tratamiento de sus datos cuando usted preste su consentimiento; cuando sea necesario para el cumplimiento de un contrato con usted o por imperativo de la ley. Por lo tanto, AUTOGO se asegurará que este consentimiento se dé de manera expresa y verificable, pudiendo el usuario retirar este consentimiento cuando él considere. La retirada del consentimiento no condicionará la ejecución del contrato de suscripción o las relaciones generadas con anterioridad.
          </p>

          <h2 className="text-2xl font-bold text-[#0A4F6E] mt-8 mb-4">4.- DERECHOS DEL USUARIO EN RELACIÓN CON EL TRATAMIENTO DE SUS DATOS</h2>
          <p className="mb-4">
            El usuario tiene los siguientes derechos sobre sus datos, de acuerdo con la normativa vigente en protección de datos:
          </p>
          <ol className="list-decimal list-inside mb-4 space-y-2">
            <li>
              <strong>Derecho de acceso:</strong> para el conocimiento de qué datos del usuario se están utilizando; para entender su tratamiento; su categorización; sus destinatarios y su plazo de conservación.
            </li>
            <li>
              <strong>Derecho de rectificación:</strong> para rectificar los datos personales inexactos que le conciernen y para que se completen los que estén incompletos.
            </li>
            <li>
              <strong>Derecho de supresión:</strong> para la supresión de los datos personales que le conciernen cuando ya no sean necesarios para los fines del tratamiento; cuando el interesado retire su consentimiento; cuando los datos hayan sido tratados ilícitamente y por obligación legal.
            </li>
            <li>
              <strong>Derecho a la limitación del tratamiento:</strong> cuando el usuario impugne la exactitud de sus datos.
            </li>
            <li>
              <strong>Derecho a la portabilidad:</strong> para recibir los datos personales que le incumben.
            </li>
            <li>
              <strong>Derecho de oposición:</strong> de los datos personales que le conciernen por motivos relacionados con su situación particular.
            </li>
          </ol>
          <p className="mb-4">El ejercicio de estos derechos por parte del usuario no comportará en ningún caso un trato discriminatorio o de grado inferior.</p>
          <p className="mb-4">
            Para el ejercicio de estos derechos será necesario que el usuario envíe un correo electrónico a la casilla{' '}
            <a href="mailto:dpo@autogodelivery.com" className="text-[#39FF77] hover:underline">
              dpo@autogodelivery.com
            </a>{' '}
            en el cual deberá especificar el derecho que quiera ejercer y respecto a qué datos personales y, asimismo, indicar su nombre, apellido, DNI y domicilio a efectos de futuras notificaciones y acreditar su identidad con copia de un documento oficial de identificación que lo identifique legalmente.
          </p>
          <p className="mb-4">
            En el caso de que haya una divergencia con AUTOGO en cuanto al tratamiento de sus datos, el usuario podrá presentar una reclamación ante la autoridad de control española, es decir, la Agencia Española de Protección de Datos a través del siguiente enlace:{' '}
            <a href="https://www.aepd.es/" target="_blank" rel="noopener noreferrer" className="text-[#39FF77] hover:underline">
              https://www.aepd.es/
            </a>
          </p>
          <p className="mb-4">
            Se salvaguarda la confidencialidad de las comunicaciones privadas entre AUTOGO y el usuario y en ningún caso se transferirán a terceros a menos que así se requiera para cumplir el fin del tratamiento de datos. Asimismo, en caso de que los datos sean requeridos por vía legal, administrativa o judicial, AUTOGO se verá obligada a revelar los mismos, pero siempre en la medida en que la legislación y normas de procedimiento lo permitan.
          </p>

          <h2 className="text-2xl font-bold text-[#0A4F6E] mt-8 mb-4">5.- CONSERVACIÓN DE LOS DATOS</h2>
          <p className="mb-4">
            Se conservarán los datos personales del usuario el tiempo que sea necesario para cumplir los fines de tratamiento que describe esta política de privacidad. Para ello, se estudiará el tiempo necesario de conservación que se necesite de los datos y se intentará reducir este tiempo al menor tiempo posible. Una vez se cumpla el tiempo de conservación, AUTOGO los eliminará o destruirá de manera segura.
          </p>

          <h2 className="text-2xl font-bold text-[#0A4F6E] mt-8 mb-4">6.- MODIFICACIÓN DE LA POLÍTICA DE PRIVACIDAD</h2>
          <p className="mb-4">
            AUTOGO podrá modificar esta política de privacidad de acuerdo a su propio criterio; por un cambio legislativo, jurisprudencial o doctrinal de la Agencia Española de Protección de Datos, así como a prácticas de la industria. No se comunicará al usuario esta modificación de manera directa, debido a esto será recomendable que el usuario visite la página web con regularidad para comprobar si se ha producido alguna modificación.
          </p>

          <h2 className="text-2xl font-bold text-[#0A4F6E] mt-8 mb-4">7.- RESPONSABLE DEL TRATAMIENTO DE DATOS</h2>
          <p className="mb-4">
            En caso de que el usuario tenga alguna duda en cuanto al tratamiento de sus datos, podrá ponerse en contacto con el responsable del tratamiento, a través de la siguiente información de contacto:
          </p>
          <div className="bg-gray-50 p-6 rounded-lg mb-4">
            <p className="mb-2">
              <strong>AUTOGO – PYRAMID LOGISTICS SL</strong>
            </p>
            <p className="mb-2">Domicilio: Av Olof Palme 6, 08840, Viladecans, Barcelona</p>
            <p className="mb-2">
              Correo electrónico:{' '}
              <a href="mailto:dpo@autogodelivery.com" className="text-[#39FF77] hover:underline">
                dpo@autogodelivery.com
              </a>
            </p>
            <p>CIF B72448764</p>
          </div>
          <p className="mb-4">
            Las respuestas a las solicitudes se responderán en el plazo máximo de 2 meses desde la fecha de envío por el delegado de protección de datos.
          </p>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
